import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
  BreakPointTablet,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    padding: 0,
    '& [class*="actions"]': {
      padding: `0px ${theme.spacing.space16}px ${theme.spacing.space24}px ${theme.spacing.space16}px !important`,
      [BreakPointDesktop]: {
        padding: `0px ${theme.spacing.space48}px ${theme.spacing.space48}px ${theme.spacing.space48}px !important`,
      },
    },
  },
  title: {
    marginTop: theme.spacing.space24,
    [BreakPointDesktop]: {
      fontSize: "32px !important",
      fontWeight: "700 !important",
      lineHeight: "45px !important",
    },
  },
  content: {
    width: "100%",
    padding: `0px ${theme.spacing.space16}px`,
    boxSizing: "border-box",
    [BreakPointDesktop]: {
      padding: `0px ${theme.spacing.space48}px`,
    },
  },
  contentPopup: {
    [BreakPointMobile]: {
      paddingBottom: 0,
    },
    [BreakPointTablet]: {
      paddingBottom: 0,
    },
  },
  video: {
    width: "100%",
    aspectRatio: "16 / 9",
    border: "none",
  },
  contentQr: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  descLarge: {
    textAlign: "left",
    color: theme.colors.TextSilver,
  },

  qrCode: {
    display: "block",
    width: "140px !important",
    height: "140px !important",
    borderRadius: theme.radius.medium,
    marginTop: theme.spacing.space24,
  },
}));
